/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../node_modules/bootstrap/dist/css/bootstrap.css.ngstyle';
import * as i1 from '../theme/css/material-dashboard.css.ngstyle';
import * as i2 from '../node_modules/ng2-toastr/ng2-toastr.css.ngstyle';
import * as i3 from '../node_modules/perfect-scrollbar/dist/css/perfect-scrollbar.css.ngstyle';
import * as i4 from '../node_modules/@swimlane/ngx-dnd/release/index.css.ngstyle';
import * as i5 from '@angular/core';
import * as i6 from '@angular/router';
import * as i7 from '../../app/app.component';
import * as i8 from 'ng2-toastr/src/toast-manager';
import * as i9 from '../../app/services/configService';
const styles_AppComponent:any[] = [i0.styles,i1.styles,i2.styles,i3.styles,i4.styles];
export const RenderType_AppComponent:i5.RendererType2 = i5.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i5.ɵViewDefinition {
  return i5.ɵvid(0,[(_l()(),i5.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i5.ɵdid(212992,(null as any),0,i6.RouterOutlet,[i6.ChildrenOutletContexts,i5.ViewContainerRef,
          i5.ComponentFactoryResolver,[8,(null as any)],i5.ChangeDetectorRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i5.ɵViewDefinition {
  return i5.ɵvid(0,[(_l()(),i5.ɵeld(16777216,(null as any),(null as any),1,'my-app',
      ([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,
      RenderType_AppComponent)),i5.ɵdid(4243456,(null as any),0,i7.AppComponent,[i8.ToastsManager,
      i5.ViewContainerRef,i9.ConfigService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const AppComponentNgFactory:i5.ComponentFactory<i7.AppComponent> = i5.ɵccf('my-app',
    i7.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnQuaHRtbCIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8bXktYXBwPjwvbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NDQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBOzZCQUFBLFVBQUE7MENBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./compiled/app/app.component.ngfactory.ts